module.exports = function getResource(label, vars = []) {
    let resources = {
        showBarcode: 'Show Barcode'
    };

    return resources[label];
};
